import { memo } from 'react';

import { type Clip, ClipType } from '@air/api/types';
import { formatDuration } from '@air/utilities';
import { ClipUtils } from '@air/utils-clips';
import { cn } from '@air/utils-tailwind';

import { GalleryAssetCardBadge } from '~/components/gallery/GalleryAssetCardBadge';

export type VideoDurationBadgeProps = {
  className?: string;
  clip: Clip;
};

export const VideoDurationBadge = memo(({ className, clip }: VideoDurationBadgeProps) => {
  if (clip.type !== ClipType.video || !ClipUtils.isTranscoded(clip.status) || !clip.duration) {
    return null;
  }

  return (
    <GalleryAssetCardBadge className={cn('h-4 w-auto rounded-4 px-1 font-medium text-10 leading-none', className)}>
      {formatDuration(clip.duration)}
    </GalleryAssetCardBadge>
  );
});

VideoDurationBadge.displayName = 'VideoDurationBadge';
